import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inner-page" }
const _hoisted_2 = {
  key: 1,
  class: "section-tenders"
}
const _hoisted_3 = { class: "tenders" }
const _hoisted_4 = {
  key: 0,
  class: "tenders__search is-saved-searches"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "tenders__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSecondary = _resolveComponent("HeaderSecondary")!
  const _component_SearchMobile = _resolveComponent("SearchMobile")!
  const _component_SidebarSearch = _resolveComponent("SidebarSearch")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_EmptyCard = _resolveComponent("EmptyCard")!
  const _component_TenderCard = _resolveComponent("TenderCard")!
  const _component_ThePagination = _resolveComponent("ThePagination")!
  const _component_FooterMobile = _resolveComponent("FooterMobile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSecondary),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SearchMobile),
      _createVNode(_component_SidebarSearch),
      _createElementVNode("main", null, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : _createCommentVNode("", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.getTenders.total !== 0 || (_ctx.getTenders.total == 0 && _ctx.hasSearchedTenders))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("form", {
                        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCompanySearch && _ctx.handleCompanySearch(...args)), ["prevent"]))
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: _ctx.$t('company_page.search_placeholder'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryCompany) = $event))
                        }, null, 8, _hoisted_5), [
                          [_vModelText, _ctx.queryCompany]
                        ])
                      ], 32)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.getTenders.total == 0)
                    ? (_openBlock(), _createBlock(_component_EmptyCard, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTenders.data, (tender) => {
                    return (_openBlock(), _createBlock(_component_TenderCard, {
                      tender: tender,
                      key: tender.id
                    }, null, 8, ["tender"]))
                  }), 128))
                ])
              ]),
              (_ctx.getTenders.total > 0)
                ? (_openBlock(), _createBlock(_component_ThePagination, {
                    key: 0,
                    maxPage: _ctx.getTenders.max_page
                  }, null, 8, ["maxPage"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FooterMobile)
  ], 64))
}